// extracted by mini-css-extract-plugin
module.exports = {"eventNameTooltip":"StatisticInfo_eventNameTooltip__2O5_T","name":"StatisticInfo_name__2pCDU"};